import { useState, useEffect } from 'react';
import { can as checkPermission } from '../lib/permissions.js';

export const useAuth = () => {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'user') {
        try {
          setUser(e.newValue ? JSON.parse(e.newValue) : null);
        } catch {
          setUser(null);
        }
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const updateUser = (newUser) => {
    if (newUser) {
      localStorage.setItem('user', JSON.stringify(newUser));
    } else {
      localStorage.removeItem('user');
    }
    setUser(newUser);
  };

  const can = (permission) => {
    if (!user?.role) return false;
    return checkPermission(user.role, permission);
  };

  const isAdmin = can('manage_users');
  const isSuperAdmin = user?.role === 'superadmin';

  return { user, can, isAdmin, isSuperAdmin, updateUser };
};
